import $ from 'jquery'
import Cookies from 'js-cookie'

const body = document.body

const setThemeVars = () => {
  const gutter = 12
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  body.style.setProperty('--main-width', `${documentWidth}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  if (mainContainer) {
    const mainContainerWidth = mainContainer.clientWidth

    const col = document.querySelector('.vn-col-sizer')
    const colWidth = col.clientWidth

    body.style.setProperty(
      '--space-width',
      `${(documentWidth - mainContainerWidth) / 2 + gutter}px`
    )

    body.style.setProperty('--container-width', `${mainContainerWidth}px`)
    body.style.setProperty('--col-width', `${colWidth}px`)
  }
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$('.cookie__closer').on('click', function () {
  $('.cookie').slideToggle(250)
  Cookies.set('smatConsent', '1', { expires: 60 })
})
